<template>
	<div class="container">
		<b-modal
			body-bg-variant="light"
			header-bg-variant="light"
			hide-footer
			header-class="py-0"
			id="modal-sustitutos"
			size="xl"
		>
			<!--Articulo original-->
			<div class="row mx-1 mt-1">
				<div class="col-12 tituloProducto">
					<p>Producto</p>
				</div>
			</div>
			<div class="d-block d-md-none">
				<card-producto
					:item="articulo"
					:modoTarjeta="true"
					@agregarCantidad="agregarCantidad"
					@mostrarDetalle="mostrarDetalle"
					class="d-flex justify-content-center mt-1"
				></card-producto>
			</div>
			<div class="d-none d-md-block m-3">
				<div class="row justify-content-center">
					<card-producto
						:item="articulo"
						:modoTarjeta="false"
						@agregarCantidad="agregarCantidad"
						@mostrarDetalle="mostrarDetalle"
					></card-producto>
				</div>
			</div>
			<!--Sustitutos-->
			<div class="row mx-1 mt-4">
				<div class="col-12 tituloSustituto">
					<p>Sustitutos</p>
				</div>
			</div>
			<div class="d-block d-md-none">
				<card-producto
					:item="item"
					:key="item.codArticulo"
					:modoTarjeta="true"
					@agregarCantidad="agregarCantidad"
					@mostrarDetalle="mostrarDetalle"
					class="d-flex justify-content-center mt1"
					v-for="item in sustitutos"
				></card-producto>
			</div>
			<div class="d-none d-md-block m-3">
				<div class="row justify-content-center">
					<card-producto
						:item="item"
						:key="item.codArticulo"
						:modoTarjeta="false"
						@agregarCantidad="agregarCantidad"
						@mostrarDetalle="mostrarDetalle"
						v-for="item in sustitutos"
					></card-producto>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
	import CardProducto from "@/components/clientes/CardProducto"

	export default {
		props: ["articulo", "sustitutos"],
		data() {
			return {}
		},
		components: {
			CardProducto
		},
		methods: {
			agregarCantidad(item) {
				//console.log(item)
				this.$emit("agregarCantidad", item)
			},
			mostrarDetalle(codArticulo) {
				//console.log(codArticulo)
				this.$router.push({
					path: `/clientes/detalle-producto/${codArticulo}`
				})
			}
		}
	}
</script>
<style scoped>
	.colorAzul {
		color: var(--bg-menu-blue);
	}
	.colorAmarillo {
		color: var(--bg-yellow);
	}
	.negrita {
		font-weight: bold;
	}
	.tituloProducto {
		background: var(--bg-menu-blue);
		color: white;
		font-weight: bold;
		height: 40px;
		line-height: 40px;
	}
	.tituloSustituto {
		background: var(--bg-yellow);
		color: white;
		font-weight: bold;
		height: 40px;
		line-height: 40px;
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		.ImgProducto {
			width: 200px;
			height: 200px;
		}
		.ImgNuevo {
			width: 80px;
			height: 30px;
		}
		.img-generico {
			width: 26px;
			height: 26px;
		}
		.sizeFont1 {
			font-size: 14px;
		}
		.sizeFont2 {
			font-size: 13px;
		}
		.txtStyle {
			border: 1px solid var(--bg-menu-blue);
			border-top-left-radius: 5px;
			border-bottom-left-radius: 5px;
			border-top-right-radius: 0px;
			border-bottom-right-radius: 0px;
			color: var(--bg-menu-blue);
		}
		.btnStyle {
			background: var(--bg-menu-blue);
			color: white;
			border: 0px;
			font-size: 13px;
			width: 400px;
			border-top-right-radius: 5px;
			border-bottom-right-radius: 5px;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		.ImgProducto {
			width: 200px;
			height: 200px;
		}
		.ImgNuevo {
			width: 80px;
			height: 30px;
		}
		.img-generico {
			width: 26px;
			height: 26px;
		}
		.sizeFont1 {
			font-size: 14px;
		}
		.sizeFont2 {
			font-size: 13px;
		}
		.txtStyle {
			border: 1px solid var(--bg-menu-blue);
			border-top-left-radius: 5px;
			border-bottom-left-radius: 5px;
			border-top-right-radius: 0px;
			border-bottom-right-radius: 0px;
			color: var(--bg-menu-blue);
		}
		.btnStyle {
			background: var(--bg-menu-blue);
			color: white;
			border: 0px;
			font-size: 13px;
			width: 400px;
			border-top-right-radius: 5px;
			border-bottom-right-radius: 5px;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
	}
</style>